/**
 * Use Alert Dialog when an action is blocked for a reason and the user can take action
 * to unblock it.
 *
 * Example: not enough storage
 */

import React from 'react';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

import { CrossCircledFilledIcon } from '../icons/cross-circled-filled.icon';

import styles from './alert-dialog.module.scss';

interface AlertDialogProps {
  title: string;

  description: string;

  buttonText: string;

  /**
   *
   */
  onAccept?: () => void;

  /**
   * Close the modal without action
   */
  onCancel?: () => void;
}

export const AlertDialog: React.FC<AlertDialogProps> = ({
  title,
  description,
  buttonText,
  onAccept,
  onCancel,
}) => (
  <Dialog
    onClose={onCancel}
    actions={[
      <TextButton key="cancel" text="Cancel" onClick={onCancel} />,
      <ElevatedButton key="upgrade" onClick={onAccept} text={buttonText} autoFocus />,
    ]}
  >
    <div className={styles.container}>
      <div className={styles.icon}>
        <CrossCircledFilledIcon />
      </div>

      <h1 className={styles.title}>{title}</h1>
      <p className={styles.description}>{description}</p>
    </div>
  </Dialog>
);
